import { MenuCtrl } from "./menu/menu"
import { DatalayersMap, fields, IOmniaShell, OmniaModuleId, SharedFieldsService, str } from "./omnia"
import { MainCtrl } from "./satellite/main/main"
import { TerramapManager } from "./terramap/components/Index"
import { IDatalayersService } from "./types"

type View = "layers" | "imagery"

export class DatalayersCtrl extends omnia.shell.Module {


    static create(): ng.IDirective {

        return omnia.defineDirective(DatalayersCtrl, "app/datalayers/datalayers.html", {
            map: "=?"
        });
    }

    private _map: DatalayersMap
    private _enableImagery = false

    private _view: View = "layers"

    static $inject = ["$scope", "OmniaDatalayersService", "OmniaShell", "OmniaFieldsMapContext"];

    constructor(
        $scope: ng.IScope,
        private svc: IDatalayersService,
        shell: IOmniaShell,
        private mapCtxt: fields.IFieldsMapContainerContext) {

        super($scope, shell, "icon-map-layers", str.Modules.MapLayers, OmniaModuleId.Layers);

    }

    $onInit() {

        if (!this.checkPermission(p => p.mapLayers)) {
            return
        }

        this.register()
        this.setupMap()

        this._enableImagery = !!this.svc.holding?.Satellite?.enabled

        this.startFirstComponent("omnia-datalayers-menu", () => this.refresh())

    }

    protected dispose() {

        this.map?.dispose();

    }


    private setupMap() {

        this._map = new DatalayersMap(this.mapCtxt);

        this._map.fieldsLayer.fillSelectedStyle = false;
        this._map.croppingLayer.fillSelectedStyle = false;
        this._map.croppingLayer.selectable = false;

        this.$scope.$watch("vm.mapCtxt.fieldSvc.selectedItems", () => this._map.updateMapSelection());

        this.$scope.$watch(
            "vm.mapCtxt.fieldSvc.lastLocatedItems",
            ({ items }: SharedFieldsService["lastLocatedItems"]) => {
                this._map.showFeaturesWithData(items, true);
            }
        );
    }


    refresh() {

        return this.svc.refresh()

    }

    private register() {

        this.registerComponent("omnia-datalayers-menu", {
            width: 350,
            attrs: { "map": "vm.map" }
        });

        this.registerComponent("omnia-datalayers-layer-edit", {
            width: 350,
            attrs: { "map": "vm.map" },
            refreshOnClose: true
        });

        this.registerComponent("omnia-datalayers-manager", {
            width: Number.POSITIVE_INFINITY,
            attrs: {},
            refreshOnClose: true,
        });

        this.registerComponent("omnia-satellite-main", {
            width: Number.POSITIVE_INFINITY,
            attrs: {},
            refreshOnClose: true,
            blocking: false
        });

        this.registerComponent("omnia-layers-terramap", {
            reactComponent: TerramapManager,
            width: Number.POSITIVE_INFINITY,
            attrs: { "map": "vm.map" },
            refreshOnClose: true,
            blocking: false
        });

    }

    get map(): DatalayersMap {
        return this._map;
    }

    set map(value: DatalayersMap) {
        this._map = value;
    }

    get view() {
        return this._view
    }

    set view(value) {

        this._view = value
        const current = this.getCurrentComponentView()

        if ((current == "layers") && (value == "imagery")) {
            this.startComponent({ component: "omnia-satellite-main" })
        }

        else if ((current == "imagery") && (value == "layers")) {
            this.closeComponent(this.getCurrentContext())
        }

    }

    getCurrentComponentView(): View {

        const cmp = this.getCurrentComponent()

        if (cmp instanceof MenuCtrl) {
            return "layers"
        }

        if (cmp instanceof MainCtrl) {
            return "imagery"
        }

    }
    get showViewSelector() {
        return this._enableImagery && (!!this.getCurrentComponentView())
    }

    isComponentFullScreen() {
        const cmp = this.getCurrentContext()
        return cmp && (cmp.width == Number.POSITIVE_INFINITY)
    }

}
